import { ProtectedZone } from './types'

export const CANVAS_WIDTH = 1650 // 11" @ 150 DPI
export const CANVAS_HEIGHT = 1275 // 8.5" @ 150 DPI

export const PROTECTED_ZONES: ProtectedZone[] = [
  { x: 310, y: 180, width: 1320, height: 50, label: 'Name Field' },
  { x: 310, y: 240, width: 1320, height: 50, label: 'License # Field' },
  { x: 310, y: 300, width: 1320, height: 50, label: 'License State Field' },
  { x: 310, y: 360, width: 1320, height: 50, label: 'License Type Field' },
  { x: 310, y: 450, width: 1320, height: 50, label: 'Has Completed Field' },
  { x: 310, y: 510, width: 1320, height: 50, label: 'Date Field' },
  { x: 310, y: 570, width: 1320, height: 50, label: 'Hours Field' },
  {
    x: 0,
    y: 1075,
    width: 1650,
    height: 200,
    label: 'Legal Statements/Disclaimers',
  },
]

export const FONT_SIZES = [12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 60, 72]
export const STEPS = ['Upload Image', 'Configure Background', 'Customize Text']
